import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorRouteComponent } from './error-route/error-route.component';
import { ResolverService } from './services/resolver.service';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./modules/user-forms/user-forms.module').then(
        (m) => m.UserFormsModule
      ),
    canLoad: [ResolverService],
  },
  {
    path: 'form',
    loadChildren: () =>
      import('./modules/dynamic-forms/dynamic-forms.module').then(
        (m) => m.DynamicFormsModule
      ),
    canLoad: [ResolverService],
  },
  {
    path: 'unsubscribe',
    loadChildren: () =>
      import('./modules/email-unsubscribe/email-unsubscribe.module').then(
        (m) => m.EmailUnsubscribeModule
      ),
    canLoad: [ResolverService],
  },
  { path: 'error-page', component: ErrorRouteComponent },
  { path: '**', redirectTo: 'error-page' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
